import { useBreakpoints } from "../../hooks/use-breakpoints";
import { cn } from "../../utils/class-names";
import { buttonV2, ButtonV2, ButtonV2Props } from "../button-v2";

type DialogButtonProps = Omit<ButtonV2Props, "variant">;

export function DialogButton(props: DialogButtonProps): JSX.Element {
  const { children } = props;

  const { md } = useBreakpoints();

  return (
    <ButtonV2 {...props} variant={md ? "tertiary" : "secondary"}>
      {children}
    </ButtonV2>
  );
}
